import { IconProps } from "../types";

export const UploadResultIcon: React.FC<IconProps> = ({ fillColor }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
    >
      <path
        d="M0.5 7.5C0.5 3.63526 3.64127 0.5 7.49612 0.5C11.351 0.5 14.5 3.63526 14.5 7.5C14.5 11.3647 11.3587 14.5 7.49612 14.5C3.63352 14.5 0.5 11.3725 0.5 7.5ZM12.8479 7.5C12.8479 4.551 10.459 2.16075 7.50388 2.16075C4.54875 2.16075 2.16759 4.551 2.16759 7.5C2.16759 10.449 4.55651 12.8392 7.50388 12.8392C10.4512 12.8392 12.8479 10.449 12.8479 7.5ZM3.6723 7.86474C3.6723 7.52328 3.93601 7.2439 4.2928 7.2439H6.87562V3.6663C6.87562 3.32483 7.14709 3.05322 7.49612 3.05322C7.84515 3.05322 8.11662 3.32483 8.11662 3.6663V7.86474C8.11662 8.20621 7.84515 8.47783 7.49612 8.47783H4.2928C3.94377 8.47783 3.6723 8.21397 3.6723 7.86474Z"
        fill={fillColor ?? "#333333"}
      />
    </svg>
  );
};
